import TerminalIntegral from './terminal_integral.vue';

export default TerminalIntegral;
